'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import Footer from '../footer/Footer';

var SingleColumnLayout = function SingleColumnLayout(_ref) {
  var children = _ref.children,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["children", "className"]);

  return /*#__PURE__*/_jsxs("div", Object.assign({
    className: className + " single-column-layout"
  }, otherProps, {
    children: [children, /*#__PURE__*/_jsx(Footer, {})]
  }));
};

export default SingleColumnLayout;